import { render, staticRenderFns } from "./sy.vue?vue&type=template&id=0008865c&scoped=true"
import script from "./sy.vue?vue&type=script&lang=js"
export * from "./sy.vue?vue&type=script&lang=js"
import style0 from "./sy.vue?vue&type=style&index=0&id=0008865c&prod&scoped=true&lang=css"
import style1 from "./sy.vue?vue&type=style&index=1&id=0008865c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0008865c",
  null
  
)

export default component.exports